var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandaddaudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3797 22.7602C10.8197 22.7602 10.393 22.6202 10.0997 22.3402C9.81969 22.0602 9.67969 21.7002 9.67969 21.2602C9.67969 20.8469 9.79302 20.4735 10.0197 20.1402C10.2464 19.7935 10.5397 19.5202 10.8997 19.3202C11.2597 19.1069 11.6397 19.0002 12.0397 19.0002C12.3997 19.0002 12.713 19.0735 12.9797 19.2202V10.7002L20.8597 8.7002V18.5202C20.8597 19.2402 20.7064 19.8602 20.3997 20.3802C20.1064 20.9002 19.7197 21.2935 19.2397 21.5602C18.7597 21.8269 18.253 21.9602 17.7197 21.9602C17.1597 21.9602 16.733 21.8202 16.4397 21.5402C16.1464 21.2602 15.9997 20.9002 15.9997 20.4602C15.9997 20.0469 16.113 19.6735 16.3397 19.3402C16.5797 18.9935 16.8797 18.7202 17.2397 18.5202C17.5997 18.3069 17.9797 18.2002 18.3797 18.2002C18.7264 18.2002 19.033 18.2735 19.2997 18.4202V11.0002L14.5197 12.3202V19.3202C14.5197 20.0402 14.3664 20.6602 14.0597 21.1802C13.7664 21.7002 13.3797 22.0935 12.8997 22.3602C12.4197 22.6269 11.913 22.7602 11.3797 22.7602Z",
    fill: "#151514"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 30,
    height: 22,
    rx: 2,
    stroke: "#151514",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandaddaudio);
export default __webpack_public_path__ + "static/media/standaddaudio.0e405699.svg";
export { ForwardRef as ReactComponent };var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandaddaudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3797 22.7602C10.8197 22.7602 10.393 22.6202 10.0997 22.3402C9.81969 22.0602 9.67969 21.7002 9.67969 21.2602C9.67969 20.8469 9.79302 20.4735 10.0197 20.1402C10.2464 19.7935 10.5397 19.5202 10.8997 19.3202C11.2597 19.1069 11.6397 19.0002 12.0397 19.0002C12.3997 19.0002 12.713 19.0735 12.9797 19.2202V10.7002L20.8597 8.7002V18.5202C20.8597 19.2402 20.7064 19.8602 20.3997 20.3802C20.1064 20.9002 19.7197 21.2935 19.2397 21.5602C18.7597 21.8269 18.253 21.9602 17.7197 21.9602C17.1597 21.9602 16.733 21.8202 16.4397 21.5402C16.1464 21.2602 15.9997 20.9002 15.9997 20.4602C15.9997 20.0469 16.113 19.6735 16.3397 19.3402C16.5797 18.9935 16.8797 18.7202 17.2397 18.5202C17.5997 18.3069 17.9797 18.2002 18.3797 18.2002C18.7264 18.2002 19.033 18.2735 19.2997 18.4202V11.0002L14.5197 12.3202V19.3202C14.5197 20.0402 14.3664 20.6602 14.0597 21.1802C13.7664 21.7002 13.3797 22.0935 12.8997 22.3602C12.4197 22.6269 11.913 22.7602 11.3797 22.7602Z",
    fill: "#151514"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 30,
    height: 22,
    rx: 2,
    stroke: "#151514",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandaddaudio);
export default __webpack_public_path__ + "static/media/standaddaudio.0e405699.svg";
export { ForwardRef as ReactComponent };